import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Register from '@/views/Register.vue'
import Login from '@/views/Login.vue'
import Lobby from '@/views/Lobby.vue'
import Verify from '@/views/Verify.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import GameManagerGame from '../views/GameManagerGame'


const Join = () => import(/* webpackChunkName: "join" */ '@/views/Join.vue')
const About = () => import(/* webpackChunkName: "join" */ '@/views/About.vue')

// pouzivani import() - lazy loading dane komponenty, zmensuje load time, pokud se rozdeli do chunku - https://router.vuejs.org/guide/advanced/lazy-loading.html
const Game = () => import(/* webpackChunkName: "game" */ '@/views/Game.vue')
const GameOverview = () => import(/* webpackChunkName: "game" */ '@/components/game/GameOverview.vue')
const SetCampaigns = () => import(/* webpackChunkName: "game" */ '@/components/game/SetCampaigns.vue')
const ArchiveCampaigns = () => import(/* webpackChunkName: "game" */ '@/components/game/ArchiveCampaigns.vue')
const ArchiveProducts = () => import(/* webpackChunkName: "game" */ '@/components/game/ArchiveProducts.vue')
const EditProducts = () => import(/* webpackChunkName: "game" */ '@/components/game/EditProducts.vue')
const PurchaseData = () => import(/* webpackChunkName: "game" */ '@/components/game/PurchaseData.vue')

const gameManager = () => import(/* webpackChunkName: "gameManager" */ '@/views/GameManager.vue')
const gameManagerGame = () => import(/* webpackChunkName: "gameManager" */ '@/views/GameManagerGame.vue')
const allGames = () => import(/* webpackChunkName: "gameManager" */ '@/components/gameManager/allGames.vue')
const newGame = () => import(/* webpackChunkName: "gameManager" */ '@/components/gameManager/newGame.vue')
const users = () => import(/* webpackChunkName: "gameManager" */ '@/components/gameManager/Users.vue')
const gameManagerLobby = () => import(/* webpackChunkName: "gameManager" */ '@/components/gameManager/gameManagerLobby.vue')
const gameSettings = () => import(/* webpackChunkName: "gameManager" */ '@/components/gameManager/gameSettings.vue')
const gameOverviewManager = () => import(/* webpackChunkName: "gameManager" */ '@/components/gameManager/gameOverviewManager.vue')
const gameChartsManager = () => import(/* webpackChunkName: "gameManager" */ '@/components/gameManager/gameChartsManager.vue')
const viewGameAsTeam = () => import(/* webpackChunkName: "gameManager" */ '@/components/gameManager/viewGameAsTeam.vue')




Vue.use(VueRouter)

const authMiddleware = (requireAuth = true) => ({
  beforeEnter: async (to, from, next) => {
    const signedIn = await store.dispatch('fetchMe')
    if ((requireAuth && requireAuth !== 'admin') && (store.getters.amIAdmin || store.getters.amIOwner)) {
      next({ name: 'GameManager' })
    } else if ((signedIn && !requireAuth) || (requireAuth === 'admin' && (!store.getters.amIAdmin && !store.getters.amIOwner))) {
      next({ name: 'Join' })
    } else if (!signedIn && requireAuth) {
      next({ name: 'Login' })
    } else {
      next()
    }
  }
})

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    ...authMiddleware(false),
  },
  {
    path: '/game',
    name: 'Game',
    // nacte komponentu Game do defaultniho router view, pak presmeruje na GameOverview - nacitani ciste kvuli tomu, ze router potrebuje mit nejakou komponentu
    component: Game,
    redirect: '/game/GameOverview',
    ...authMiddleware(),
    // pouzivani children routeru https://router.vuejs.org/guide/essentials/nested-routes.html
    children: [
      {
        path: 'GameOverview',
        components: {
          // pouzivani vice router views - https://router.vuejs.org/guide/essentials/named-views.html, tudiz router view s name gameView se pouziva, jen kdyz je explicitne receno
          default: Game,
          gameView: GameOverview,
        },
        name: 'Game.GameOverview'
      },
      {
        path: 'SetCampaigns',
        components: {
          default: Game,
          gameView: SetCampaigns,
        },
        name: 'Game.SetCampaigns'
      },
      {
        path: 'ArchiveCampaigns',
        components: {
          default: Game,
          gameView: ArchiveCampaigns,
        },
        name: 'Game.ArchiveCampaigns'
      },
      {
        path: 'ArchiveProducts',
        components: {
          default: Game,
          gameView: ArchiveProducts,
        },
        name: 'Game.ArchiveProducts'
      },
      {
        path: 'EditProducts',
        components: {
          default: Game,
          gameView: EditProducts,
        },
        name: 'Game.EditProducts'
      },
      {
        path: 'PurchaseData',
        components: {
          default: Game,
          gameView: PurchaseData,
        },
        name: 'Game.PurchaseData'
      }
    ]
  },
  {
    path: '/join',
    name: 'Join',
    component: Join,
    ...authMiddleware(),
  },
  {
    path: '/team',
    name: 'Lobby',
    component: Lobby,
    ...authMiddleware(),
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    ...authMiddleware(false),
  },
  {
    path: '/register/verify',
    name: 'Verify',
    component: Verify,
    ...authMiddleware(false),
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    ...authMiddleware(false),
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    ...authMiddleware(false),
  },
  {
    path: '/gameManager',
    name: 'GameManager',
    component: gameManager,
    redirect: '/gameManager/allGames',
    ...authMiddleware('admin'),
    children: [
      {
        path: 'allGames',
        name: 'GameManager.allGames',
        component: allGames
      },
      {
        path: 'newGame',
        name: 'GameManager.newGame',
        component: newGame
      },
      {
        path: 'users',
        name: 'GameManager.users',
        component: users
      },
      {
        path: 'team',
        name: 'GameManager.team',
        component: viewGameAsTeam
      },
      {
        path: 'game',
        name: 'GameManager.game',
        component: GameManagerGame,
        children: [
          {
            path: 'lobby',
            name: 'GameManager.game.lobby',
            component: gameManagerLobby
          },
          {
            path: 'settings',
            name: 'GameManager.game.settings',
            component: gameSettings
          },
          {
            path: 'overview',
            name: 'GameManager.game.overview',
            component: gameOverviewManager
          },
          {
            path: 'charts',
            name: 'GameManager.game.charts',
            component: gameChartsManager
          },
        ]
      },
    ]
  }
]

const router = new VueRouter({
  routes,
  //base: '/adgame-frontend/',
})

export default router
